<template>
  <div class="md-layout center-content fill-height" data-test-id="account-setup-complete">
    <md-card class="md-layout-item md-size-50 md-small-size-100">
      <md-card-header class="text-center">
        <div class="md-title">{{$t('setupComplete')}}</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <div class="carrus-field">
              {{$t('passwordSuccessful')}}
            </div>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <router-link to="/login">
          <md-button type="submit" class="md-primary md-raised submit-button" data-test-id="submit-button">{{$t('logIn')}}</md-button>
        </router-link>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { MdButton, MdCard, MdField, MdLayout } from 'vue-material/dist/components'

Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdField)
Vue.use(MdLayout)

export default {
  name: 'RegisterLogin'
}
</script>
